import router from './orders.router'

export default { router }
